export const SET_O2_REQUEST = 'SET_O2_REQUEST';
export const SET_O2_FAILED = 'SET_O2_FAILED';
export const SET_O2_OWN_ORGANIZATION_NAME_SUCCESS = 'SET_O2_OWN_ORGANIZATION_NAME_SUCCESS';
export const SET_O2_OWN_ORGANIZATION_OFFERING_SUCCESS = 'SET_O2_OWN_ORGANIZATION_OFFERING_SUCCESS';
export const SET_O2_TOP_MARKET_DRIVERS_SUCCESS = 'SET_O2_TOP_MARKET_DRIVERS_SUCCESS';
export const SET_02_ORGANIZATION_DRIVERS_SUCCESS = 'SET_02_ORGANIZATION_DRIVERS_SUCCESS';
export const SET_O2_COMPETITORS_DRIVERS_SUCCESS = 'SET_O2_COMPETITORS_DRIVERS_SUCCESS';
export const CLEAN_O2 = 'CLEAN_O2';
